var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReject(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4826 8.524C16.761 8.2456 16.761 7.79422 16.4826 7.51581C16.2042 7.23741 15.7528 7.23741 15.4744 7.51581L11.9992 10.991L8.524 7.51581C8.2456 7.23741 7.79422 7.23741 7.51581 7.51581C7.23741 7.79422 7.23741 8.2456 7.51581 8.524L10.991 11.9992L7.51581 15.4744C7.23741 15.7528 7.23741 16.2042 7.51581 16.4826C7.79422 16.761 8.2456 16.761 8.524 16.4826L11.9992 13.0074L15.4744 16.4826C15.7528 16.761 16.2042 16.761 16.4826 16.4826C16.761 16.2042 16.761 15.7528 16.4826 15.4744L13.0074 11.9992L16.4826 8.524Z",
    fill: "#F44A68"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReject);
export default __webpack_public_path__ + "static/media/Reject.f7a5bf2c.svg";
export { ForwardRef as ReactComponent };